'use client';

import React, {useEffect, useState} from 'react';
import posthog from 'posthog-js';
import {PostHogProvider} from 'posthog-js/react';
import {browserLog} from "@/lib/otlp/logger/browser-logging";

export function CSPostHogProvider({children}: { readonly children: React.ReactNode }) {
    const [isPostHogReady, setIsPostHogReady] = useState(false);

    useEffect(() => {
        if (typeof window !== 'undefined'
            && !posthog.__loaded && process.env.NODE_ENV === 'production') {
            posthog.init('phc_DTI42XrscpKwkdfAZVVlKLNm881W26B3lD3kBL1FRtC', {
                api_host: 'https://us.i.posthog.com',
                person_profiles: 'identified_only',
                capture_pageview: true,
                capture_pageleave: true,
                enable_recording_console_log: true,
                ip: true
            });
            browserLog.info("PostHog initialized", {source: 'PostHog', status: 'initialized'});
            setIsPostHogReady(true);
        }
        if (typeof window !== 'undefined') {
            browserLog.info("Checking PostHog status", {source: 'PostHog', loaded: posthog.__loaded});
        }
    }, []);
    if (!isPostHogReady) return children; // Prevent SSR mismatch

    return (
        <PostHogProvider client={posthog}>
            {children}
        </PostHogProvider>
    );
}
